import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as PendingAppMdls from '../models/PendingAppointmentModel';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface PendingAppointmentLoad { type: 'PENDINGAPPOINTMENT_LOAD', newState: PendingAppMdls.PendingAppointmentList }
export interface PendingAppointmentLoading { type: 'PENDINGAPPOINTMENT_LOADING' }
//export interface PendingAppointmentError { type: 'PENDINGAPPOINTMENT_ERROR', error: string }

export type KnownAction = PendingAppointmentLoad | PendingAppointmentLoading | ResetStore;

export const actionCreators = {
    loadAppointments: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();          
        const pSession = appState.sessionState;
        var ServiceMasterNumber = pSession.SelectedSM.id;
        var CompanyCode = pSession.SelectedAR.companyCode;
        try {

            dispatch({ type: 'PENDINGAPPOINTMENT_LOADING' });
            sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/proxy/appointments?pServiceMaster=' + ServiceMasterNumber + '&pCompanyCode=' + CompanyCode,
                {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(response => response.json() as Promise<APIContainer>)
                .then(container => {
                    if (container.success) {
                        const data: PendingAppMdls.PendingAppointmentModel[]  = container.data;
                        dispatch({ type: 'PENDINGAPPOINTMENT_LOAD', newState: {items:data, loading:false  }  });
                    } else {

                        sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                    }
                });
        } catch (e) {
            sawinFunc.log({ message: e, logType: LogTypes.Error, clientMessage: '' });
        }
    }
};

export const reducer: Reducer<PendingAppMdls.PendingAppointmentList> = (state: PendingAppMdls.PendingAppointmentList | undefined, incomingAction: Action): PendingAppMdls.PendingAppointmentList => {

    if (state === undefined) {
        return { ...PendingAppMdls.initialPendingAppointmentState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'PENDINGAPPOINTMENT_LOADING':
            return { ...state, loading: true }
        case 'PENDINGAPPOINTMENT_LOAD':
            const pendingAppointmentAction = incomingAction as PendingAppointmentLoad;
            return pendingAppointmentAction.newState;
        case 'STORE_RESET':
            return { ...PendingAppMdls.initialPendingAppointmentState };
        default:
            return state;
    }
}; 